import { createTheme } from '@mui/material/styles';
import { dark } from '@mui/material/styles/createPalette';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#F7E900',
      contrastText: '#000000',
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
      alternate: '#2a2a2a',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#000000',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#ffffff',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            '&:-webkit-autofill': {
              WebkitBoxShadow: '0 0 0 100px #3a3a3a inset',
              WebkitTextFillColor: '#ffffff',
            },
            '&:-webkit-autofill:hover': {
              WebkitBoxShadow: '0 0 0 100px #3a3a3a inset',
              WebkitTextFillColor: '#ffffff',
            },
            '&:-webkit-autofill:focus': {
              WebkitBoxShadow: '0 0 0 100px #3a3a3a inset',
              WebkitTextFillColor: '#ffffff',
            },
          },
        },
      },
    },
  },
});

export default darkTheme;